import React, { useEffect, useState } from 'react';
import { Api } from '../../api';
import { DashboardLayout } from '../../layouts/dashboard-layout/DashboardLayout';
import './Dossiers.scss';
import { DossiersContainer } from '../../features/dossiers-container/DossiersContainer';
import { DossierV2, IDossierWithRelation } from '../../models/DossierV2';
import { MultiDossierUnreadStatus } from '../../models/UnreadStatus';

export function PersonalDossiers(): JSX.Element {
  const [dossiersWithRelation, setDossiersWithRelation] = useState<IDossierWithRelation[]>([]);
  const [unreadStatus, setUnreadStatus] = useState<MultiDossierUnreadStatus>(new MultiDossierUnreadStatus({}));
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    Api.listUserDossiersWithUserRelation()
      .then(list => {
        setDossiersWithRelation(list);
        return Api.getUnreadStatusAllDossiers();
      })
      .then(unread => setUnreadStatus(unread))
      .catch(error => console.error('Loading dossiers failed:', error))
      .finally(() => setLoading(false));
  }, []);

  const handleArchiveDossier = (dossier: DossierV2, { restore }: { restore?: boolean } = {}): void => {
    const newList: IDossierWithRelation[] = dossiersWithRelation.map(item => {
      if (!item.dossier.match(dossier)) {
        return item;
      }

      return { ...item, dossier: new DossierV2({ ...item.dossier, archived: !restore }) };
    });

    setDossiersWithRelation(newList);
  };

  const handleUnarchiveDossier = (dossier: DossierV2): void => {
    handleArchiveDossier(dossier, { restore: true });
  };

  return (
    <DashboardLayout backButton={false} noTabs={true}>
      <DossiersContainer dossiersWithRelation={dossiersWithRelation} loading={loading} unreadStatus={unreadStatus} onArchiveDossier={handleArchiveDossier} onUnarchiveDossier={handleUnarchiveDossier} />
    </DashboardLayout>
  );
}
